import { AddressText, ShippingMethodText, ShipToTitle, UnavailableDataPlaceholderText } from "constants/text";
import { convertToTitleCase } from "utils/string";
import { BillToShipToBoxWrapper } from "../BillToShipToBox.styles";
import { models } from "types/api/viewModels";
import { formatAddress } from "utils/address.ts";

interface ShipToBoxProps {
	orderDetail: models["OrderDetailViewModel"];
	dataTestIdPrefix: string;
}

const ShipToBox = ({ orderDetail, dataTestIdPrefix }: ShipToBoxProps) => {
	return (
		<BillToShipToBoxWrapper hasBorder>
			<h6>{ShipToTitle}</h6>
			<div>
				<div>
					<b>{AddressText}</b>
					<p
						data-testid={`${dataTestIdPrefix}-shipToAddress`}
						style={{ whiteSpace: "pre-line" }}
					>
						{formatAddress(orderDetail?.shipToAddress)}
					</p>
				</div>
				<div>
					<b data-testid={dataTestIdPrefix + "-shipViaName"}>{ShippingMethodText}</b>
					<p>{convertToTitleCase(orderDetail?.shippingDetails?.shipVia) || UnavailableDataPlaceholderText}</p>
					<b>Delivery Contact</b>
					<p>{orderDetail?.shipToAddress?.phoneNumber || UnavailableDataPlaceholderText}</p>
				</div>
			</div>
		</BillToShipToBoxWrapper>
	);
};

export default ShipToBox;
